import ApisServiceApp from '@api/ApisServiceApp'
import { TypeId } from '@interfaces/commonInterfaces'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'


// gét chi đơn mua
export function getDetailInvoice(id: string) {
  try {
    return ApisServiceApp.get('/invoice/' + id + '/detail-invoice')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


// đơn mua
export function getListInvoice(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/invoice/filter-invoice', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function createSyncInvoice(invoiceId: TypeId) {
  try {
    return ApisServiceApp.post('/invoice/' + invoiceId + '/sync-invoice')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function createCancelSyncInvoice(invoiceId: TypeId) {
  try {
    return ApisServiceApp.post('/invoice/' + invoiceId + '/cancel-sync-invoice')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteInvoice(id: TypeId) {
  try {
    return ApisServiceApp.delete('/invoice/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteMultiInvoice(ids: TypeId[]) {
  try {
    return ApisServiceApp.delete('/invoice/multi-delete', { data: ids })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

